var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('ChatPrivate',{attrs:{"user":_vm.user}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('ChatList')],1)])])])
}
var staticRenderFns = []

export { render, staticRenderFns }